import { render, staticRenderFns } from "./mark-on-file-banner.vue?vue&type=template&id=03bf67a6&scoped=true&"
import script from "./mark-on-file-banner.vue?vue&type=script&lang=ts&"
export * from "./mark-on-file-banner.vue?vue&type=script&lang=ts&"
import style0 from "./mark-on-file-banner.vue?vue&type=style&index=0&id=03bf67a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf67a6",
  null
  
)

export default component.exports